import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { mergeActions } from '@/modules/kartoteka/partner/store/types';
import { updateEditAction } from '@/main/store/actionsFunctions';

import { PARTNER_MERGE as name, DEPENDENT_TABLES_MERGE as depTableNames, CRUMB_LABEL_KEY, MERGE } from '../constants';
import { apiProvider } from '../api';
import { edit, dropdownList } from './edit';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList,
	edit,
	depTableNames,
	depTableSettings: {
		[MERGE]: {
			filter(state) {
				return {
					...(state.edit.ZakaznikId && { CilId: state.edit.ZakaznikId }),
					ZdrojId: state.props.kontaktId,
				};
			},
		},
	},
	localState: {},
	extraActions: {
		[mergeActions.GET_PARTNER]: ({ commit, state, dispatch }, id) => updateEditAction(
			state,
			commit,
			dispatch,
			apiProvider.getPartner(id),
		),
	},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		kontaktId: null as number | null,
	},
});
